/* eslint-disable */
/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Soft UI Dashboard React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

import OTPSignin from "layouts/authentication/sign-in/OTP";
import { roles } from "constants/config";
import UserManger from "layouts/UserManger";
import Category from "layouts/Category/CategoryTables";
import DetailCategoryTables from "layouts/DetailCategory/DetailCategoryTables";
import Sticker from "layouts/Sticker/index";
import DesignSample from "layouts/DesignSample/index";
import AddDetailTemplate from "layouts/DetailCategory/data/AddDetailTemplate";
import FAIcon from "assets/images/icons/daikin-admin/report/2FA.svg";
import FAIconInactive from "assets/images/icons/daikin-admin/report/2FA-Inactive.svg";
import UserIcon from "assets/images/icons/daikin-admin/report/Icon-addUser.svg";
import UserIconInactive from "assets/images/icons/daikin-admin/report/Icon-addUser-Inactive.svg";
import Register2FAIntroduce from "layouts/authentication/2FA/Register2FAIntroduce";
import SignIn from "layouts/authentication/sign-in/indexLogin";
import SignUp from "layouts/authentication/sign-up/index";
import Forgot from "layouts/authentication/forgot/indexForgetPass";
import ChangePass from "layouts/authentication/changePass/changePass";
import TwoFA from "layouts/authentication/2FA";
import DashboardIcon from "assets/images/icons/daikin-admin/report/Dashboard-Active.svg";
import DashboardIconInactive from "assets/images/icons/daikin-admin/report/Dashboard-Inactive.svg";
import HomePage from "layouts/dashboard";
import Profile from "layouts/profile";
import ErrorPage from "layouts/error/ErrorPage";
import UserDetail from "layouts/UserDetail";
import DesignView from "layouts/DesignView";
const routes = [
  {
    type: "childnone",
    title: "Trang chủ",
    key: "Dashboard",
    display: true,
    icon: DashboardIcon,
    iconInActive: DashboardIconInactive,
    roles: [roles.admin],
    permissionCode: "HOME_PAGE",
    route: "/",
    color: "#3C7363",
    component: <HomePage workingPage="Trang chủ" childPage={["Trang chủ"]} />,
  },
  {
    type: "childnone",
    title: "Trang chủ",
    key: "Dashboard",
    display: true,
    icon: DashboardIcon,
    iconInActive: DashboardIconInactive,
    roles: [roles.admin],
    permissionCode: "HOME_PAGE",
    route: "/profile",
    color: "#3C7363",
    component: <Profile workingPage="Trang chủ" childPage={["Trang chủ"]} />,
  },
  {
    type: "childnone",
    title: "Trang chủ",
    key: "Dashboard",
    display: true,
    icon: DashboardIcon,
    iconInActive: DashboardIconInactive,
    roles: [roles.admin],
    permissionCode: "NOT_REQUIRED",
    route: "/user-detail",
    color: "#3C7363",
    component: (
      <UserDetail workingPage="Thông tin người dùng" childPage={["Thông tin người dùng"]} />
    ),
  },
  {
    type: "childnone",
    title: "Người dùng",
    key: "UserManager",
    display: true,
    iconInActive: UserIconInactive,
    icon: UserIcon,
    roles: [roles.admin],
    permissionCode: "USER_MANAGEMENT",
    route: "/UserManager",
    component: <UserManger workingPage="Quản lý người dùng" childPage={["Người dùng"]} />,
  },
  {
    type: "childnone",
    title: "DANH SÁCH DANH MỤC",
    key: "Category",
    display: true,
    iconInActive: UserIconInactive,
    icon: UserIcon,
    roles: [roles.admin],
    permissionCode: "CATEGORY_MANAGEMENT",
    route: "/Category",
    component: (
      <Category workingPage="Quản lý danh mục sản phẩm" childPage={["DANH SÁCH DANH MỤC"]} />
    ),
  },
  {
    type: "childnone",
    title: "CHI TIẾT DANH MỤC",
    key: "Category",
    display: false,
    permissionCode: "NOT_REQUIRED",
    route: "/Category/detail",
    component: <DetailCategoryTables />,
  },
  {
    type: "childnone",
    title: "Thêm mới template",
    key: "AddTemplate",
    display: false,
    permissionCode: "NOT_REQUIRED",
    route: "/Category/detail/add",
    component: <AddDetailTemplate />,
  },
  {
    type: "childnone",
    title: "QUẢN LÝ STICKER",
    key: "Sticker",
    display: true,
    iconInActive: UserIconInactive,
    icon: UserIcon,
    roles: [roles.admin],
    permissionCode: "STICKER_MANAGEMENT",
    route: "/Sticker",
    component: <Sticker workingPage="Quản lý sticker" childPage={["DANH SÁCH STICKER"]} />,
  },
  {
    type: "childnone",
    title: "QUẢN LÝ MẪU DESIGN",
    key: "Sample",
    display: true,
    iconInActive: UserIconInactive,
    icon: UserIcon,
    roles: [roles.admin],
    permissionCode: "SAMPLE_MANAGEMENT",
    route: "/Sample",
    component: <DesignSample workingPage="Quản lý mẫu" childPage={["DANH SÁCH MẪU DESIGN"]} />,
  },
  {
    type: "childnone",
    title: "Xác thực 2 bước",
    key: "introduce",
    display: true,
    icon: FAIcon,
    iconInActive: FAIconInactive,
    roles: [roles.user, roles.admin],
    route: "/Register2FA/introduce",
    component: (
      <TwoFA workingPage="Kích hoạt xác thực 2 bước" childPage={["Kích hoạt xác thực 2 bước"]} />
    ),
  },
  {
    name: "Đăng nhập",
    key: "sign-in",
    route: "/authentication/sign-in",
    component: <SignIn />,
    noneSidebar: true,
    public: true,
  },
  {
    name: "Đăng ký",
    key: "sign-up",
    route: "/authentication/sign-up",
    component: <SignUp />,
    noneSidebar: true,
    public: true,
  },
  {
    name: "Quên mật khẩu",
    key: "forgot-password",
    route: "/authentication/forgot-password",
    component: <Forgot />,
    noneSidebar: true,
    public: true,
  },
  {
    name: "Xác nhập OTP đăng nhập",
    key: "confirm-otp-signin",
    route: "/authentication/sign-in/OTP",
    component: <OTPSignin />,
    noneSidebar: true,
  },
  {
    name: "Register 2FA",
    key: "Regis-2FA-intro",
    route: "/register-2FA/introduce",
    component: <Register2FAIntroduce />,
    roles: [roles.employee],
    noneSidebar: true,
  },
  {
    name: "ChangePassword",
    key: "Change-Password",
    route: "/authentication/change-pass",
    component: <ChangePass />,
    noneSidebar: true,
    public: true,
  },
  {
    name: "Lỗi hệ thống",
    key: "error",
    route: "/error",
    component: <ErrorPage />,
    noneSidebar: true,
    public: true,
  },
  {
    type: "childnone",
    key: "DesignView",
    display: true,
    route: "/DesignView",
    color: "#3C7363",
    component: <DesignView />,
  },
];

export default routes;
